{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
  "title": "EmbeddedDisclosurePolicy",
  "type": "object",
  "properties": {
    "policy": {
      "type": "string"
    }
  },
  "required": [
    "policy"
  ]
}